module.exports = __webpack_public_path__ + "img/new-ultra-background.bf5f6c47.png";